import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import SocialShare from './SocialShare';

const { FiShare2 } = FiIcons;

const ShareButton = ({ weatherData, typhoonData, location = 'Iligan City', className = '', size = 'default' }) => {
  const [isShareOpen, setIsShareOpen] = useState(false);

  const sizeClasses = {
    small: 'p-2 text-sm',
    default: 'px-4 py-2 text-sm',
    large: 'px-6 py-3 text-base'
  };

  const iconSizes = {
    small: 'text-sm',
    default: 'text-base',
    large: 'text-lg'
  };

  return (
    <>
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => setIsShareOpen(true)}
        className={`flex items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors ${sizeClasses[size]} ${className}`}
        title="Share weather update"
      >
        <SafeIcon icon={FiShare2} className={iconSizes[size]} />
        {size !== 'small' && <span className="font-medium">Share</span>}
      </motion.button>

      <SocialShare
        weatherData={weatherData}
        typhoonData={typhoonData}
        location={location}
        isOpen={isShareOpen}
        onClose={() => setIsShareOpen(false)}
      />
    </>
  );
};

export default ShareButton;